import { motion } from 'framer-motion';
import { Brain, Users, TrendingUp, Lightbulb, Shield, Award } from 'lucide-react';

const features = [
  {
    icon: <Brain className="h-6 w-6" />,
    title: "Stratégie & cas d’usage",
    description: "Identification des opportunités IA concrètes adaptées à vos métiers et vos enjeux."
  },
  {
    icon: <Users className="h-6 w-6" />,
    title: "Formation des équipes",
    description: "Ateliers et formations IA pour rendre vos équipes rapidement autonomes et opérationnelles."
  },
  {
    icon: <TrendingUp className="h-6 w-6" />,
    title: "Automatisation de process",
    description: "Automatisation des tâches répétitives, workflows, emails, reporting et opérations internes."
  },
  {
    icon: <Lightbulb className="h-6 w-6" />,
    title: "Agents IA métier",
    description: "Création d’agents IA adaptés à vos besoins : support, commercial, RH, finance ou opérations."
  },
  {
    icon: <Shield className="h-6 w-6" />,
    title: "IA responsable & sécurisée",
    description: "Approche conforme RGPD avec prise en compte des enjeux sécurité, confidentialité et gouvernance."
  },
  {
    icon: <Award className="h-6 w-6" />,
    title: "Résultats concrets",
    description: "Des projets IA déployés rapidement avec un impact direct sur la productivité et les opérations."
  }
];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } }
};

const Features = () => {
  return (
    <section className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white py-20 md:py-28">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="heading-lg mb-6">Ce que nous faisons</h2>

          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            Formation IA, accompagnement stratégique, agents IA et automatisation :
            nous aidons les PME et ETI à transformer concrètement leurs opérations grâce à l’intelligence artificielle.
          </p>
        </div>

        <motion.div 
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
        >
          {features.map((feature, index) => (
            <motion.div 
              key={index}
              className="bg-gray-50 p-8 rounded-xl hover:shadow-md transition-shadow duration-300"
              variants={item}
            >
              <div className="bg-primary/10 p-3 rounded-full w-fit mb-6">
                <div className="text-primary">
                  {feature.icon}
                </div>
              </div>

              <h3 className="text-xl text-gray-900 font-semibold mb-3">
                {feature.title}
              </h3>

              <p className="text-gray-600">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Features;